import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ResponsibleMaintenanceService = {
    list: (filters) => axios.post(API_KEEPER + "/pclMaintenanceGroups/list", filters).then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/pclMaintenanceGroups/get/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/pclMaintenanceGroups/create", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (data) => axios.post(API_KEEPER + "/pclMaintenanceGroups/update", data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/pclMaintenanceGroups/delete/" + id).catch((err) => { throw err }),

    isMaintenanceGroupInUse: async (id) => axios.get(API_KEEPER + "/pclMaintenanceGroups/isMaintenanceGroupInUse/" + id).then(({data}) => data).catch((err) => { throw err }),

    maintenanceGroupName: () => axios.post(API_KEEPER + "/pclMaintenanceGroups/list", []).then(({ data }) => data.map(d => ({value: d.name, label: d.name,})))
};

export default ResponsibleMaintenanceService;